import styled from 'styled-components';

export const ProductNavigationLink = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
